import clientAttentionIcon from "../../assets/icons/1.svg";
import contentPlanningIcon from "../../assets/icons/2 (1).svg";
import metricMeasureIcon from "../../assets/icons/2.svg";
import competencyAnalysIcon from "../../assets/icons/3 (1).svg";
import communityGestionIcon from "../../assets/icons/3.svg";
import copyWritingIcon from "../../assets/icons/4.svg";
import historyDesignIcon from "../../assets/icons/5.svg";
import fbADSIcon from "../../assets/icons/6.svg";
import networkMonitorIcon from "../../assets/icons/7.svg";

export const myServicesLabel = "Mis Servicios";

export const servicesList = [
  {
    icon: communityGestionIcon,
    label: "Gestion de comunidades",
    description: "Fomento una comunidad activa, para mantener a la audiencia.",
  },
  {
    icon: contentPlanningIcon,
    label: "Planificación de contenido",
    description:
      "Diseño un calendario de publicaciones estratégico para garantizar un flujo constante y coherente de contenido relevante.",
  },
  {
    icon: copyWritingIcon,
    label: "Copywriting",
    description:
      "Redacto textos persuasivos y atractivos para captar la atención y fomentar la interacción tu la audiencia.",
  },
  {
    icon: competencyAnalysIcon,
    label: "Análisis de la competencia",
    description:
      "Estudio a tus competidores para identificar oportunidades y mejorar tus estrategias de marketing.",
  },
  {
    icon: historyDesignIcon,
    label: "Diseño de historias",
    description:
      "Diseño historias visualmente atractivas para aumentar la interacción en redes sociales.",
  },
  {
    icon: clientAttentionIcon,
    label: "Atención al cliente",
    description:
      "Gestiono consultas y comentarios en redes sociales para asegurar una respuesta rápida y eficaz, mejorando la satisfacción del cliente.",
  },
  {
    icon: networkMonitorIcon,
    label: "Gestión y monitoreo de redes",
    description:
      "Superviso tus perfiles sociales, respondiendo a la actividad en tiempo real y optimizando tu presencia en línea.",
  },
  {
    icon: fbADSIcon,
    label: "Pauta en Facebook ADS",
    description:
      "Gestiono campañas publicitarias en Facebook e Instagram para alcanzar a tu público objetivo y maximizar el retorno de inversión.",
  },
  {
    icon: metricMeasureIcon,
    label: "Informe con métricas",
    description:
      "Proporciono informes detallados con las métricas clave para evaluar el rendimiento y ajustar las estrategias de marketing.",
  },
];
